// https://vuex.vuejs.org/en/mutations.html
import dayjs from 'dayjs'

export default {
  // ***** PREFERENCES *****
  loader (state, loader) {
    if (loader === true) {
      state.loader = { show: true, status: null }
    } else if (loader === false) {
      state.loader = { show: false, status: null }
    } else {
      state.loader = { show: true, status: loader }
    }
  },
  drawer (state, drawer) {
    state.drawer = drawer
  },
  drawerOptions (state, drawerOptions) {
    state.drawerOptions = drawerOptions
  },
  networkType (state, networkType) {
    state.networkType = networkType
  },
  usepassword (state, usepassword) {
    state.usepassword = usepassword
  },
  usevibrate (state, usevibrate) {
    state.usevibrate = usevibrate
  },
  usebrightness (state, usebrightness) {
    state.usebrightness = usebrightness
  },
  keepscreenon (state, keepscreenon) {
    state.keepscreenon = keepscreenon
  },
  usenfc (state, usenfc) {
    state.usenfc = usenfc
  },
  useqrcodes (state, useqrcodes) {
    state.useqrcodes = useqrcodes
  },
  usemanscan (state, usemanscan) {
    state.usemanscan = usemanscan
  },
  duration (state, duration) {
    state.duration = duration
  },
  offline (state, offline) {
    state.offline = offline
  },
  // ***** PARAMETRES *****
  merchantName (state, merchantName) {
    state.merchantName = merchantName
  },
  userName (state, userName) {
    state.userName = userName
  },
  teleparameters (state, teleparameters) {
    state.teleparameters = teleparameters
  },
  creditPermissions (state, creditPermissions) {
    state.creditPermissions = creditPermissions
  },
  loyalty (state, loyalty) {
    state.loyalty = loyalty
  },
  event (state, event) {
    state.event = event
  },
  // ***** APPLICATION *****
  amount (state, amount) {
    state.amount = amount
  },
  tipAmount (state, tipAmount) {
    state.tipAmount = tipAmount
  },
  donationAmount (state, donationAmount) {
    state.donationAmount = donationAmount
  },
  tipRef (state, tipRef) {
    state.tipRef = tipRef
  },
  donationRef (state, donationRef) {
    state.donationRef = donationRef
  },
  waiterNumber (state, waiterNumber) {
    state.waiterNumber = waiterNumber
  },
  shops (state, shops) {
    state.shops = shops
  },
  listproducts (state, listproducts) {
    state.listproducts = listproducts
  },
  actionItems (state, actionItems) {
    state.actionItems = actionItems
  },
  menuItems (state, menuItems) {
    state.menuItems = menuItems
  },
  favoriteItem (state, favoriteItem) {
    state.favoriteItem = favoriteItem
  },
  favoriteScan (state, favoriteScan) {
    state.favoriteScan = favoriteScan
  },
  //
  addProduct (state, index) {
    state.listproducts[index.i].products[index.j].quantity++
  },
  deleteProduct (state, index) {
    if (state.listproducts[index.i].products[index.j] > 0) {
      state.listproducts[index.i].products[index.j].quantity--
    }
  },
  //
  idConsigne (state, id) {
    state.ecocup.idConsigne = id
  },
  idDeconsigne (state, id) {
    state.ecocup.idDeconsigne = id
  },
  consignes (state, consignes) {
    state.consignes = consignes
  },
  //
  manageBankingTickets (state, manageBankingTickets) {
    state.manageBankingTickets = manageBankingTickets
  },
  printCustomerTicket (state, printCustomerTicket) {
    state.printCustomerTicket = printCustomerTicket
  },
  printMerchantTicket (state, printMerchantTicket) {
    state.printMerchantTicket = printMerchantTicket
  },
  neptingInfos (state, neptingInfos) {
    state.neptingInfos = neptingInfos
  },
  intent (state, intent) {
    state.intent = intent
  },
  printer (state, printer) {
    state.printer = printer
  },
  qrCodeUrl (state, qrCodeUrl) {
    state.qrCodeUrl = qrCodeUrl
  },
  campaignDeactivated (state, min) {
    state.campaignDeactivated = min !== null ? dayjs().add(min, 'm') : null
  },
}
